module.exports = __webpack_public_path__ + "img/participacionyconsulta.5a8f32cb.jpg";